import React from 'react';
import PropTypes from 'prop-types';
import PaginationComponent from './Pagination';
import { Select, Row, Col } from 'antd';
const { Option } = Select;

const TableFooter = props => {
  const {
    noOfItemsToDisplay,
    changeNoOfItemsToDisplay,
    currentItemsDisplayed,
    handlePageChange,
    currentPage,
    count,
    pageSizes
  } = props;

  const itemOptions = pageSizes || [25, 50, 100, 250];
  return (
    <Row type="flex" className="footer" justify="space-between">
      <Col>
        <div>
          Display{' '}
          <Select
            defaultValue={noOfItemsToDisplay}
            value={noOfItemsToDisplay}
            style={{ width: 80 }}
            onChange={val => changeNoOfItemsToDisplay(+val)}
          >
            {itemOptions.map(item => {
              return (
                <Option key={item} value={item}>
                  {item}
                </Option>
              );
            })}
          </Select>{' '}
          Items
        </div>
      </Col>
      <Col>
        <PaginationComponent
          total={count}
          noOfItemsToDisplay={noOfItemsToDisplay}
          currentItemsDisplayed={currentItemsDisplayed}
          handlePageChange={handlePageChange}
          currentPage={currentPage}
        />
      </Col>
    </Row>
  );
};

TableFooter.propTypes = {
  noOfItemsToDisplay: PropTypes.number.isRequired,
  changeNoOfItemsToDisplay: PropTypes.func.isRequired,
  currentItemsDisplayed: PropTypes.number.isRequired,
  currentPage: PropTypes.number.isRequired,
  handlePageChange: PropTypes.func.isRequired,
  count: PropTypes.number,
  pageSizes: PropTypes.array
};

export default TableFooter;
